import { learningServiceRequest } from "./utils";

export const subjectSublevelsService = {
  async list(search) {
    const { data: response } = await learningServiceRequest({
      method: "get",
      url: "/subject_sublevels",
      params: { limit: 150, q: search },
      failureMessage: "Error loading subject sublevels",
    });
    if (response?.data?.items?.length > 0) {
      return response.data.items;
    } else {
      return [];
    }
  },
};
